import { render, staticRenderFns } from "./LoversCustom.vue?vue&type=template&id=ed6c9b28&scoped=true"
import script from "./LoversCustom.vue?vue&type=script&lang=js"
export * from "./LoversCustom.vue?vue&type=script&lang=js"
import style0 from "./LoversCustom.vue?vue&type=style&index=0&id=ed6c9b28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6c9b28",
  null
  
)

export default component.exports